(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card-options"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sd-card-previews')) {
  customElements.define('sd-card-previews', class extends HTMLElement {
    connectedCallback() {
      this.observer = new ResizeObserver(() => this.fitChoices());
      this.observer.observe(this);
      requestAnimationFrame(() => this.fitChoices());
    }
    disconnectedCallback() { this.observer?.disconnect(); }
    fitChoices() {
      this.querySelectorAll('[data-sd-option-row]').forEach(row => {
        const labels = Array.from(row.querySelectorAll('label'));
        const more = row.querySelector('[data-sd-more]');
        row.hidden = labels.length === 0;
        if (!labels.length || !row.clientWidth) return;
        labels.forEach(label => { label.hidden = false; });
        more.hidden = true;
        const gap = 4;
        const widths = labels.map(label => label.getBoundingClientRect().width);
        const total = widths.reduce((sum, width) => sum + width, 0) + gap * (labels.length - 1);
        if (total <= row.clientWidth + 0.5) return;
        more.hidden = false;
        const budget = row.clientWidth - more.getBoundingClientRect().width - gap;
        let used = 0, visible = 0, overflow = false;
        labels.forEach((label, index) => {
          const next = used + (visible ? gap : 0) + widths[index];
          if (overflow || next > budget + 0.5) { overflow = true; label.hidden = true; }
          else { used = next; visible++; }
        });
        const hidden = labels.length - visible;
        more.textContent = '+' + hidden;
        more.setAttribute('aria-label', more.dataset.label + ' (+' + hidden + ')');
      });
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
